import React from "react";

const RightArrow = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="20"
      viewBox="0 0 21 20"
      fill="none"
    >
      <path
        d="M0.566406 10C0.566406 4.47715 5.04356 0 10.5664 0C16.0893 0 20.5664 4.47715 20.5664 10C20.5664 15.5228 16.0893 20 10.5664 20C5.04356 20 0.566406 15.5228 0.566406 10ZM8.53608 14.5303C8.82897 14.8232 9.30384 14.8232 9.59674 14.5303L13.5967 10.5303C13.8896 10.2374 13.8896 9.76256 13.5967 9.46967L9.59674 5.46967C9.30384 5.17678 8.82897 5.17678 8.53608 5.46967C8.24318 5.76256 8.24318 6.23744 8.53608 6.53033L12.0057 10L8.53608 13.4697C8.24318 13.7626 8.24318 14.2374 8.53608 14.5303Z"
        fill={props.active?"#BEBEBE":"#656565"}
      />
    </svg>
  );
};

export default RightArrow;
